let UTILS = require("../libs/utils.js");
var v7750;
var v7751;
module.exports = {
  id: "raid",
  name: "Raid",
  alias: "raid",
  tag: ["Event", "#d95487", "#e86b9b"],
  party: true,
  randClassScr: 0.5,
  sendR: 5,
  endStats: ["sid", "name", "score", "time", "dmg", "reward"],
  showMS: true,
  noRegen: true,
  lives: 1,
  minPlayers: 1,
  waitTimers: [{
    time: 20000,
    msg: "starting in "
  }],
  winCondition: function (game) {
    var vLN01239 = 0;
    for (var vLN01240 = 0; vLN01240 < game.players.list.length; ++vLN01240) {
      if (game.players.list[vLN01240].lives > 0) {
        vLN01239++;
      }
    }
    if (game.gameTimerP > 0 && vLN01239 > 0) {
      return 1;
    } else {
      return 2;
    }
  },
  condition: [function (game) {
    var vLN01241 = 0;
    for (var vLN01242 = 0; vLN01242 < game.players.list.length; ++vLN01242) {
      if (game.players.list[vLN01242].lives > 0 && game.players.list[vLN01242].active) {
        vLN01241++;
      }
    }
    return vLN01241 > 0;
  }],
  onEnd: function (game) {
    if (!(game.gameTimerP <= 0)) {
      var v7752;
      var v7753 = game.mode.gameTime == null ? game.config.gameTime * 60000 : game.mode.gameTime;
      for (var vLN01243 = 0; vLN01243 < game.players.list.length; ++vLN01243) {
        v7752 = game.players.list[vLN01243];
        if (!v7752.timer && v7752.active) {
          v7752.timer = UTILS.getTime(v7753 - (game.gameTimerP || 0));
          v7752.gameTimer = v7753 - (game.gameTimerP || 0);
          if (v7752.account && v7752.gameTimer > 0 && !game.isCustom) {
            game.challenges.update(game, "time", v7752.gameTimer, null, v7752);
          }
        }
      }
    }
  },
  skipStats: ["h", "s", "crc", "step"],
  noWeap: true,
  friendly: true,
  noClan: true,
  noFreeCam: true,
  viewDis: 500,
  specMaxD: 25,
  gameTime: 360000,
  botsAsAI: true,
  noAssists: true,
  botBypassClass: true,
  noMinimap: true
};